import { Component, OnInit } from '@angular/core'
import { Video } from 'src/app/shared/interfaces/video.interface'
import { MetaService } from 'src/app/shared/services/meta.service'
import { TagService } from 'src/app/shared/services/tag.service'
import { VideoService } from 'src/app/shared/services/video.service'

@Component({
  selector: 'app-generative-ai-videos',
  templateUrl: './generative-ai-videos.component.html',
  styleUrls: ['./generative-ai-videos.component.scss']
})
export class GenerativeAiVideosComponent implements OnInit {
  videos: Video[]
  loader = true

  constructor(
    private videoService: VideoService,
    private tagService: TagService,
    private metaService: MetaService
  ) {}

  ngOnInit() {
    this.tagService.showBySlug('generative-ai').then((tag) => {
      ;(
        this.videoService.list({
          tagId: tag.id.toString(),
          withoutPagination: true
        }) as Promise<Video[]>
      ).then((videos) => {
        this.videos = videos
        this.loader = false
      })
    })

    this.metaService.setTags({
      title: 'Generative AI Videos',
      description:
        'Watch our Generative AI videos to stay informed about what is happening at the OECD AI Policy Observatory.',
      path: 'genai/videos',
      absoluteOgImage: this.metaService.defaultMeta.absoluteOgImage
    })
  }
}
